<template>
  <div class="geocoder">
    <div class="form-wrap">
      <label for="geocoder">{{ $t('geocoder.searchAddress') }}</label>
      <div id="geocoder" class="geocoder"></div>
    </div>

    <div id="map" style="width: 100%; height: 400px"></div>

    <div class="two-columns">
      <FormInput v-model="lat" :name="$t('geocoder.latitude')" type="number" step="any" required />
      <FormInput v-model="lng" :name="$t('geocoder.longitude')" type="number" step="any" required />
    </div>
  </div>
</template>

<script>
import mapbox_geo from '@mapbox/mapbox-gl-geocoder'
import mapbox from 'mapbox-gl'

import FormInput from '@/components/Form/Input/index.vue'

import mapUtils from '@/utils/mapbox'

export default {
  name: 'GeoCoder',
  props: {
    latitude: [String, Number],
    longitude: [String, Number],
    mapCenter: { type: Object, default: () => null },
  },
  data() {
    return {
      lat: this.latitude,
      lng: this.longitude,
      coordinates: [0, 0],
      map: null,
    }
  },
  components: {
    FormInput,
  },
  mixins: [mapUtils],
  computed: {
    center() {
      if (this.mapCenter) {
        return this.mapCenter
      }
      return {
        lat: this.coordinates[1] || this.lat,
        lng: this.coordinates[0] || this.lng,
      }
    },
  },
  methods: {
    initMap() {
      this.map = mapUtils.initMap({
        center: this.center,
        zoom: 13,
      })

      const geocoder = new mapbox_geo({
        accessToken: mapbox.accessToken,
        mapboxgl: mapbox,
        marker: false,
      })

      document.getElementById('geocoder').appendChild(geocoder.onAdd(this.map))

      this.map.on('load', () => {
        if (this.lat && this.lng) {
          const currentMarker = document.createElement('div')
          currentMarker.className = 'marker'
          new mapbox.Marker(currentMarker).setLngLat([this.lng, this.lat]).addTo(this.map)
        }
        geocoder.on('result', e => {
          document.querySelectorAll('.marker').forEach(e => e.remove())
          this.lat = e.result.geometry.coordinates[1]
          this.lng = e.result.geometry.coordinates[0]
          this.coordinates = e.result.geometry.coordinates
          const el = document.createElement('div')
          el.className = 'marker'
          new mapbox.Marker(el).setLngLat(this.coordinates).addTo(this.map)
        })
      })

      this.map.on('click', e => {
        document.querySelectorAll('.marker').forEach(e => e.remove())
        geocoder.clear()
        this.lat = e.lngLat.lat
        this.lng = e.lngLat.lng
        this.coordinates = [e.lngLat.lng, e.lngLat.lat]
        const el = document.createElement('div')
        el.className = 'marker'
        new mapbox.Marker(el).setLngLat(this.coordinates).addTo(this.map)
      })
    },
  },
  created() {
    this.coordinates = [this.lng, this.lat]
  },
  mounted() {
    this.initMap()
  },
  watch: {
    latitude(value) {
      this.lat = value
    },
    longitude(value) {
      this.lng = value
    },
    lat(value) {
      this.$emit('coordinates', [this.lng, value])
    },
    lng(value) {
      this.$emit('coordinates', [value, this.lat])
    },
    coordinates(value) {
      this.$emit('coordinates', value)
    },
  },
}
</script>
